module.exports = __webpack_public_path__ + "static/media/email-share_button.86635111.svg";